/*document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
  anchor.addEventListener("click", function (e) {
    e.preventDefault();
    const target = document.querySelector(this.getAttribute("href"));
    if (target) {
      target.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  });
});*/
window.addEventListener("load", () => {
  setTimeout(() => {
    // Attach click event listener to buttons with [data-ot-button] selector
    document.querySelectorAll("[data-ot-button]").forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        // Find the ".reservation-widget-button a" element
        const targetLink = document.querySelector(
          ".ot-button.ot-button-widget"
        );
        if (targetLink) {
          // Simulate a click on the target element
          targetLink.click();
          console.log("Reservation button clicked.");
        } else {
          console.warn("Reservation widget button not found.");
        }
      });
    });
  }, 1500);
});